import React from 'react';
import * as Backend from "../../backend.js";
import * as util from "../../other/util.js";
import ShipCollection from "../../share/ship-collection.js";
import ResourceVector from "../../share/resource-vector.js";
import { GameData } from "../../share/game-data.js";
import * as ICONS from "../../other/icons.js";

// Allows player to transfer ships/res into existing or new fleets .. one class that does all of that is likely a good idea XD
// Notes:
// - Transferring resources immediately has a problem if both ships are 99% full and need to exchange stuff
class FleetTransferView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = { loading: true };
        this.refreshState();
        this._handleResourcesChange = this._handleResourcesChange.bind(this);
        this._handleTransferButton = this._handleTransferButton.bind(this);
        this._handleFleetChange = this._handleFleetChange.bind(this);
    }

    refreshState() {
        let fleet_a_id = this.props.params.fleet_a_id;
        let fleet_b_id = this.props.params.fleet_b_id;
        Backend.getTwoFleetDetails(fleet_a_id, fleet_b_id, (res) => {
            this._applyStateFromServer(res);
        });
    }

    render() {
        if (this.state.loading) {
            return (<util.LoadingBar thing={"fleets"} thingName="fleet" />);
        }

        const fleets = this.state.fleets;
        const resources = this.state.resources;

        return (
            <div>
                <div style={{ display: "flex" }}>
                    <FleetHeader fleet={fleets[0]} fleet_idx={0} resources={resources} />
                    <div className="action-button" onClick={this._handleTransferButton}>Transfer</div>
                    <FleetHeader fleet={fleets[1]} fleet_idx={1} resources={resources} />
                </div>
                <div>
                    <ResourceMover fleets={fleets} resources={resources} onChangeResources={this._handleResourcesChange} />
                </div>
                <div>
                    <ShipMover fleets={fleets} onChangeFleets={this._handleFleetChange} />
                </div>
                <util.JsonDebug obj={this.state.fleets} />
            </div>
        );
    }

    _handleResourcesChange(resources) {
        const fleets = LocalHelper.copyFleets(this.state.fleets);
        fleets[0].resources = resources[0];
        fleets[1].resources = resources[1];
        this.setState({ fleets: fleets });
    }

    _handleFleetChange(fleets) {
        this.setState({ fleets: fleets });
    }

    _handleTransferButton() {
        const fleet_ids = this.state.fleets.map(fleet => fleet.id);
        const ships = this.state.fleets.map(fleet => fleet.ships.map(ship => ({ id: ship.design.id, count: ship.count })));
        const resources = this.state.fleets.map(fleet => fleet.resources);
        Backend.tryFleetTransfer({ fleet_ids: fleet_ids, ships: ships, resources: resources }, (res) => {
            this._applyStateFromServer(res);
        });
    }

    _applyStateFromServer(res) {
        if (!res.success) {
            alert(res.error);
            return;
        }
        const fleets = LocalHelper.copyFleets(res.fleets);
        const resources = new ResourceVector().init();
        resources.addVectorSparse(resources, fleets[0].resources);
        resources.addVectorSparse(resources, fleets[1].resources);
        this.setState({
            loading: false,
            fleets: fleets,
            resources: resources,
        });
    }
}

class FleetHeader extends React.Component {
    render() {
        const fleet = this.props.fleet;

        return <div style={{ flex: "50%" }}>
            <h4>
                {fleet.name ? <util.FleetLink fleetId={fleet.id} fleetName={fleet.name} /> : <div>Orbit</div>}
            </h4>
        </div>
    }
}

class ResourceMover extends React.Component {
    render() {
        const fleets = this.props.fleets;
        const resources = this.props.resources;
        const cargos = [fleets[0].resources.sumUpVector(), fleets[1].resources.sumUpVector()];

        return <div>
            <h2>Resources</h2>
            <table className="resources" style={{ width: "90%" }}>
                <tbody>
                    <tr>
                        <td style={{ width: "50%", textAlign: "end" }}><Cargo used={cargos[0]} space={fleets[0].stats.cargo} orbit={fleets[0].id === undefined} /></td>
                        <td><span className="link-button" onClick={() => this._handleAddRatioAll(0, 1.0)}>{"<<"}</span></td>
                        <td><span className="link-button" onClick={() => this._handleAddRatioAll(0, 0.1)}>{"<"}</span></td>
                        <td><span className="link-button" onClick={() => this._handleAssignRatioAll(0.5)}>{"1:1"}</span></td>
                        <td><span className="link-button" onClick={() => this._handleAddRatioAll(1, 0.1)}>{">"}</span></td>
                        <td><span className="link-button" onClick={() => this._handleAddRatioAll(1, 1.0)}>{">>"}</span></td>
                        <td style={{ width: "50%" }}><Cargo used={cargos[1]} space={fleets[1].stats.cargo} orbit={fleets[1].id === undefined} /></td>
                    </tr>
                    {
                        resources.mapSparse((res, idx) => {
                            if (res.amount === 0) {
                                return null;
                            } else {
                                return (
                                    <tr key={idx}>
                                        <td style={{ width: "50%", textAlign: "end" }}><InputField amount={fleets[0].resources[res.id]} onChange={amount => this._handleAssignSingle(0, res.id, amount)} /></td>
                                        <td><span className="link-button" onClick={() => this._handleAddRatioSingle(0, res.id, 1.0)}>{"<<"}</span></td>
                                        <td><span className="link-button" onClick={() => this._handleAddRatioSingle(0, res.id, 0.1)}>{"<"}</span></td>
                                        <td><SingleResource resource={GameData.RESOURCE_BY_ID[res.id]} amount={res.amount} /></td>
                                        <td><span className="link-button" onClick={() => this._handleAddRatioSingle(1, res.id, 0.1)}>{">"}</span></td>
                                        <td><span className="link-button" onClick={() => this._handleAddRatioSingle(1, res.id, 1.0)}>{">>"}</span></td>
                                        <td style={{ width: "50%" }}><InputField amount={fleets[1].resources[res.id]} onChange={amount => this._handleAssignSingle(1, res.id, amount)} /></td>
                                    </tr>);
                            }
                        })
                    }
                </tbody>
            </table>
        </div>
    }

    _handleAddRatioSingle(fleet_idx, res_id, ratio) {
        const resources = this._copyResources();
        let amount = Math.round(this.props.resources[res_id] * ratio + this.props.fleets[fleet_idx].resources[res_id]);
        this._assignResource(resources, fleet_idx, res_id, amount);
        this.props.onChangeResources(resources);
    }

    _handleAssignSingle(fleet_idx, res_id, amount) {
        const resources = this._copyResources();
        this._assignResource(resources, fleet_idx, res_id, amount);
        this.props.onChangeResources(resources);
    }

    _handleAddRatioAll(fleet_idx, ratio) {
        const resources = this._copyResources();
        GameData.RESOURCES.forEach((res) => {
            let amount = Math.round(this.props.resources[res.id] * ratio + this.props.fleets[fleet_idx].resources[res.id]);
            this._assignResource(resources, fleet_idx, res.id, amount);
        });
        this.props.onChangeResources(resources)
    }

    _handleAssignRatioAll(ratio) {
        const resources = this._copyResources();
        GameData.RESOURCES.forEach((res) => {
            this._assignResource(resources, 0, res.id, Math.round(this.props.resources[res.id] * ratio));
        });
        this.props.onChangeResources(resources);
    }

    _assignResource(resources, fleet_idx, res_id, amount) {
        const total_amount = this.props.resources[res_id];
        if (amount > total_amount) {
            amount = total_amount;
        }
        resources[fleet_idx][res_id] = amount;
        resources[1 - fleet_idx][res_id] = total_amount - amount;
    }

    _copyResources() {
        return [new ResourceVector().init().initSparse(this.props.fleets[0].resources), new ResourceVector().init().initSparse(this.props.fleets[1].resources)];
    }
}

class Cargo extends React.Component {
    render() {
        const is_orbit = this.props.orbit;
        const used_cargo = this.props.used;
        const available_cargo_space = this.props.space;
        const color = used_cargo > available_cargo_space && "red";
        let details = "/" + available_cargo_space + " (" + Math.round(used_cargo / available_cargo_space * 1000) / 10 + "%)";
        if (is_orbit) {
            details = " (unlimited space)";
        } else if (used_cargo > available_cargo_space && available_cargo_space === 0) {
            details = " (Overflow!)";
        }


        return <span style={{ color: color }}>
            {used_cargo} {details}
        </span>
    }
}

class SingleResource extends React.Component {
    render() {
        const resource = this.props.resource;
        const amount = this.props.amount;

        return (
            <div>
                <util.Tooltip tooltip={<util.ListInToolTip name={resource.ui_name} properties={[{ name: "Total", value: amount }]} />}>
                    <img src={ICONS.RESOURCES[resource.id]} alt={resource.ui_name} style={{ width: "30px", height: "30px" }} />
                </util.Tooltip>
            </div>
        )
    }
}

class ShipMover extends React.Component {
    render() {
        const fleets = this.props.fleets;
        this.combined_fleet = new ShipCollection().addShipCollection(fleets[0]).addShipCollection(fleets[1]);

        return <div>
            <h2>Ships</h2>
            <table className="resources" style={{ width: "90%" }}>
                <tbody>
                    <tr>
                        <td style={{ width: "50%", textAlign: "end" }}>{fleets[0].ship_count}</td>
                        <td><span className="link-button" onClick={() => this._handleAddRatioAll(0, 1.0)}>{"<<"}</span></td>
                        <td><span className="link-button" onClick={() => this._handleAddRatioAll(0, 0.1)}>{"<"}</span></td>
                        <td style={{ textAlign: "center" }}><span className="link-button" onClick={() => this._handleAssignRatioAll(0.5)}>{"1:1"}</span></td>
                        <td><span className="link-button" onClick={() => this._handleAddRatioAll(1, 0.1)}>{">"}</span></td>
                        <td><span className="link-button" onClick={() => this._handleAddRatioAll(1, 1.0)}>{">>"}</span></td>
                        <td style={{ width: "50%" }}>{fleets[1].ship_count}</td>
                    </tr>
                    {
                        this.combined_fleet.ships.map((ship, idx) =>
                            <tr key={idx}>
                                <td style={{ width: "50%", textAlign: "end" }}><InputField amount={fleets[0].getShipCount(ship.design.id)} onChange={amount => this._handleAssignSingle(0, ship.design.id, amount)} /></td>
                                <td><span className="link-button" onClick={() => this._handleAddRatioSingle(0, ship.design.id, 1.0)}>{"<<"}</span></td>
                                <td><span className="link-button" onClick={() => this._handleAddRatioSingle(0, ship.design.id, 0.1)}>{"<"}</span></td>
                                <td><SingleShip ship={ship} /></td>
                                <td><span className="link-button" onClick={() => this._handleAddRatioSingle(1, ship.design.id, 0.1)}>{">"}</span></td>
                                <td><span className="link-button" onClick={() => this._handleAddRatioSingle(1, ship.design.id, 1.0)}>{">>"}</span></td>
                                <td style={{ width: "50%" }}><InputField amount={fleets[1].getShipCount(ship.design.id)} onChange={amount => this._handleAssignSingle(1, ship.design.id, amount)} /></td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    }

    _handleAddRatioSingle(fleet_idx, ship_id, ratio) {
        const fleets = LocalHelper.copyFleets(this.props.fleets);
        let count = LocalHelper.calculateRatio(this.combined_fleet.getShipCount(ship_id), ratio) + this.props.fleets[fleet_idx].getShipCount(ship_id);
        this._assignShipCount(fleets, fleet_idx, ship_id, count);
        this.props.onChangeFleets(fleets);
    }

    _handleAssignSingle(fleet_idx, ship_id, count) {
        const fleets = LocalHelper.copyFleets(this.props.fleets);
        this._assignShipCount(fleets, fleet_idx, ship_id, count);
        this.props.onChangeFleets(fleets);
    }

    _handleAddRatioAll(fleet_idx, ratio) {
        const fleets = LocalHelper.copyFleets(this.props.fleets);
        this.combined_fleet.ships.forEach((ship) => {
            let count = LocalHelper.calculateRatio(this.combined_fleet.getShipCount(ship.design.id), ratio) + this.props.fleets[fleet_idx].getShipCount(ship.design.id);
            this._assignShipCount(fleets, fleet_idx, ship.design.id, count);
        });
        this.props.onChangeFleets(fleets);
    }

    _handleAssignRatioAll(ratio) {
        const fleets = LocalHelper.copyFleets(this.props.fleets);
        this.combined_fleet.ships.forEach((ship) => {
            let count = LocalHelper.calculateRatio(this.combined_fleet.getShipCount(ship.design.id), ratio);
            this._assignShipCount(fleets, 0, ship.design.id, count);
        });
        this.props.onChangeFleets(fleets);
    }

    _assignShipCount(fleets, fleet_idx, ship_id, count) {
        const total_count = this.combined_fleet.getShipCount(ship_id);
        if (count > total_count) {
            count = total_count;
        }
        const design = this.combined_fleet.getShips(ship_id).design;
        fleets[fleet_idx].setShipCount(design, count);
        fleets[1 - fleet_idx].setShipCount(design, total_count - count);
    }
}

class SingleShip extends React.Component {
    render() {
        const ship = this.props.ship;
        return (
            <div>
                <util.Tooltip tooltip={<util.ListInToolTip name={ship.design.name} properties={[{ name: "Total", value: ship.count }]} />}>
                    <span>{ship.design.name}</span>
                </util.Tooltip>
            </div>
        )
    }
}

class InputField extends React.Component {
    render() {
        return (
            <input value={this.props.amount} onChange={event => this.props.onChange(Number(event.target.value))} type={"Number"} />
        )
    }
}

class LocalHelper {
    static copyFleets(fleets) {
        const result = [new ShipCollection(fleets[0]), new ShipCollection(fleets[1])];
        result[0].resources = new ResourceVector().init().initSparse(result[0].resources);
        result[1].resources = new ResourceVector().init().initSparse(result[1].resources || {}); // Orbit
        return result;
    }

    static calculateRatio(total, ratio) {
        return Math.max(Math.round(total * ratio), total > 0 ? 1 : 0);
    }
}

export default util.withParams(FleetTransferView);